import { IMPACT_CONTENT, IMAGES } from '../data/content'

function ImpactSection() {
  return (
    <section className="relative py-20 px-4 bg-gradient-to-b from-white to-brand-blue-light/20 scroll-mt-20 overflow-hidden">
      {/* Decorative blue stripe at top */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-brand-blue"></div>

      <div className="max-w-[1500px] mx-auto grid lg:grid-cols-2 gap-16 items-center px-6">
        {/* Content */}
        <div className="text-center lg:text-left">
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-brand-blue mb-2">
            {IMPACT_CONTENT.title}
          </h3>
          <div className="w-32 h-1 bg-brand-blue mb-6 mx-auto lg:mx-0"></div>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-3">
            {IMPACT_CONTENT.description}
          </p>
          <p className="text-gray-600 mb-10 text-lg">
            {IMPACT_CONTENT.period}
          </p>

          {/* Stats - Horizontal Layout */}
          <div className="flex flex-wrap justify-center lg:justify-start gap-8 md:gap-12">
            {IMPACT_CONTENT.stats.map((stat, index) => (
              <div key={index} className="text-center">
                <span className="block text-5xl md:text-6xl font-heading font-bold text-brand-blue mb-2">
                  {stat.number}
                </span>
                <span className="text-gray-600 text-sm md:text-base max-w-[120px] inline-block leading-tight">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Photos with Blue Blob */}
        <div className="relative h-[450px] hidden lg:block">
          {/* Large blue blob background */}
          <div className="absolute top-8 right-0 w-[350px] h-[400px] bg-brand-blue-light rounded-[100px] opacity-70"></div>

          {/* Photo 1 - top */}
          <div
            className="absolute top-0 right-8 bg-white p-2 rounded-xl shadow-xl z-10 transform rotate-2"
            style={{ width: '260px' }}
          >
            <div className="aspect-[4/3] bg-gray-200 rounded-lg overflow-hidden">
              <img
                src={IMAGES.impact || '/images/placeholder.jpg'}
                alt="Impact photo 1"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Photo 2 - bottom, overlapping */}
          <div
            className="absolute bottom-0 right-16 bg-white p-2 rounded-xl shadow-xl z-20 transform -rotate-2"
            style={{ width: '280px' }}
          >
            <div className="aspect-[4/3] bg-gray-200 rounded-lg overflow-hidden">
              <img
                src="/images/Curriculum4.png"
                alt="Impact photo 2"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Mobile: Single image */}
        <div className="lg:hidden flex justify-center">
          <div className="relative">
            <img
              src={IMAGES.impact}
              alt="Our Impact"
              className="max-w-sm w-full rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ImpactSection
